// export const base_url = `https://alphawin.io/stacking/`
// export const base_url = `https://api.alphawin.io/stacking/`

export const base_url = `https://aibittrade.com/stacking/`
